import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

export default function CVCTooltip({ brand }) {
  const [tooltipOpen, setTootipOpen] = useState(false);

  return (
    <div className="cvc-text-container">
      <p>{brand === 'amex' ? 'CID' : 'CVC/CVV'}</p>
      <div className="question-icon-container">
        <button
          className="icon-button"
          onClick={() => setTootipOpen(!tooltipOpen)}
        >
          <FontAwesomeIcon icon={faCircleQuestion} />
        </button>
        {tooltipOpen &&
          <div className="cvc-message">
            { /* eslint-disable jsx-a11y/no-static-element-interactions */}
            <div className="text-container" onClick={() => setTootipOpen(!tooltipOpen)}>
              <div>
                <FormattedMessage
                  id="payment2.payment-form-cvv-explanation"
                  defaultMessage="The {cvcLabel} number is a code printed on your debit or credit card. With most cards it is the final {number} digits of the number printed in the signature strip on the reverse of your card."
                  values={{
                    cvcLabel: brand === 'amex' ? 'CID' : 'CVC/CVV',
                    number: brand === 'amex' ? '4' : '3',
                  }}
                />
              </div>
              <div className="card-images">
                <div className="credit-card-img">
                  <img src="https://cdn.fanatical.com/production/product/payment-logos/ccv-credit-card.png" alt="Credit/Debit card CCV/CVC" height="100%" width="100%" />
                </div>
                <div className="amex-img">
                  <img src="https://cdn.fanatical.com/production/product/payment-logos/ccv-amex.png" alt="American Express CCV/CVC" height="100%" width="100%" />
                </div>
              </div>
              <div className="close-icon">
                <FontAwesomeIcon icon={faXmark} />
              </div>
            </div>
            <div className="cvc-arrow" />
          </div>
        }
      </div>
    </div>
  );
}

CVCTooltip.propTypes = {
  brand: PropTypes.string,
};

CVCTooltip.defaultProps = {
  brand: null,
};
